import { render } from "./App.vue?vue&type=template&id=be340aca&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=be340aca&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-be340aca"

export default script